var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"password-strength",class:_vm.checkStrength(_vm.password)},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"bar-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"bar"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }